import { Iconify } from "@repo/design-system/components/ui";

export const Icon = ({ iconName, size = 14, ...otherIconConfig }) => (
    // console.log('otherIconConfig',otherIconConfig)
    <Iconify
        icon={iconName}
        width={size}
        ttLabel={otherIconConfig?.ttLabel}
        targetId={otherIconConfig?.targetId}
        {...otherIconConfig}
    />
);


{/* <iconify-icon icon={name} width={size} height={size}
    style={{ display: "block", flexShrink: 0 }} /> */}